module.exports = __webpack_public_path__ + "static/media/temp_40.e9ae1efe.jpg";